import { Component, OnInit, NgZone } from '@angular/core';
import { ModalController, AlertController } from '@ionic/angular';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/http/api.service';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { HelperService } from 'src/app/services/helper/helper.service';

@Component({
  selector: 'app-junior-aid',
  templateUrl: './junior-aid.component.html',
  styleUrls: ['./junior-aid.component.scss'],
})
export class JuniorAidComponent implements OnInit {
  queryData
  isLoading = true;
  jaList: any;
  constructor(
    private modalController: ModalController, 
    private router: Router,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration, 
    public alertController: AlertController,
    private helper: HelperService,
    private zone: NgZone
  ) { }

  ngOnInit() {
    console.log('queryData', this.queryData);
    this.jaList = this.queryData.data;
    console.log('jaList', this.jaList.length);
  }

  async delJA(jaId, index) {
    const alert = await this.alertController.create({
      message: 'Are you sure you want to Delete?',
      // cssClass:  'singlebtn-alert-custom-class py-success-alert confirmAlert',
      mode: 'ios',
      buttons: [
        {
          text: 'Yes',
          // cssClass: 'okBtnclass',
          handler: () => {
            
            this.apiService.post(this.apiConfig.deleteJAID, {id: jaId})
            .subscribe((res: any) => {
              console.log('res', res);
              if (res.data) {
                this.zone.run(()=>{
                  this.jaList.splice(index, 1);
                  console.log('jaList', this.jaList);
                });
              }
            }, err => {})
          }
        },
        {
          text: 'Cancel',
          // cssClass: 'okBtnclass cancelBtn',
          role: 'cancel',
          handler: (blah) => {

          }
        }
      ]
    });
    await alert.present();
  }

  redirectToPage(data){
    this.closeModal();
    this.helper.pushRootPage('/tabs/dashboard/enrollment/junior-aid-enrollment-form', {uId: data}).catch(() => {});
  }

  closeModal(){
    this.modalController.dismiss()
  }

}
